import React from 'react'
import parse from 'html-react-parser'
// @ts-ignore
import { Tag, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import MetadataIconsContainer from './MetadataIconsContainer'

type TagIconProps = {
  message: string
  tooltipPrefix: string
}

const TagIcon = ({ message, tooltipPrefix }: TagIconProps) => {
  const theme = useDisplayTheme() as Theme
  const color = sys[theme].text.placeholder
  const tooltip = parse(`${tooltipPrefix}<br>${message}`)

  return (
    <Tooltip mode={theme} enabled content={tooltip}>
      <div>
        <MetadataIconsContainer message={message}>
          <Tag color={color} />
        </MetadataIconsContainer>
      </div>
    </Tooltip>
  )
}

export default TagIcon
